<script setup lang="ts">
import { collapseProps } from 'naive-ui';

const props = defineProps(collapseProps);
</script>

<template>
  <!-- Themed n-collapse (Collapse section in gaia-light.json) — the expandable
       fields list on the review detail. Compose n-collapse-item children;
       use #header-extra for risk pills / checks. -->
  <n-collapse v-bind="props">
    <slot />
  </n-collapse>
</template>
